export const infoSvg = (
  <svg
    data-testid="ock-infoSvg"
    role="img"
    aria-label="ock-infoSvg"
    width="100%"
    height="100%"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Info</title>
    <path
      d="M5 10C7.7625 10 10 7.7625 10 5C10 2.2375 7.7625 0 5 0C2.2375 0 0 2.2375 0 5C0 7.7625 2.2375 10 5 10ZM4.58333 2.08333H5.41667V2.91667H4.58333V2.08333ZM4.58333 3.75H5.41667V7.91667H4.58333V3.75Z"
      className="fill-ock-foreground"
    />
  </svg>
);
